import { ScheduleSettingsUI } from "@/components/settings/schedule-settings";
import { ScheduleSchema, User, useUpdateUserSchedule } from "@/lib/api/user";
import { useAbility } from "@/lib/casl/ability-context";
import { hasPrivilegedAccessFromAbility } from "@/lib/casl/privileged-access";
import { getUserTimezoneWithDefault } from "@/lib/utils/timezone";

const daysOfWeek = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

interface UserMentorScheduleProps {
  user: User;
}

export function UserMentorSchedule({ user }: UserMentorScheduleProps) {
  const ability = useAbility();
  const canUpdateUsers =
    hasPrivilegedAccessFromAbility(ability) && ability.can("update", "users");
  const { mutateAsync: updateScheduleMutation, isPending } =
    useUpdateUserSchedule(user.id);

  const defaultValues: ScheduleSchema = {
    schedule:
      user?.metadata?.schedule ||
      daysOfWeek.map((day) => {
        if (
          day === "Monday" ||
          day === "Tuesday" ||
          day === "Wednesday" ||
          day === "Thursday"
        ) {
          return { day, isOnline: true, startTime: "17:00", endTime: "22:00" };
        } else if (day === "Friday") {
          return { day, isOnline: true, startTime: "17:00", endTime: "19:00" };
        } else {
          return { day, isOnline: false, startTime: "17:00", endTime: "19:00" };
        }
      }),
    timezone: getUserTimezoneWithDefault(user),
    autoDetectTimezone: user?.metadata?.auto_detect_timezone ?? true,
  };

  const handleSubmit = async (data: ScheduleSchema) => {
    await updateScheduleMutation(data);
  };

  return (
    <ScheduleSettingsUI
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
      isPending={isPending}
      userName={user.name ?? undefined}
      disabled={!canUpdateUsers}
    />
  );
}
